import React, { useEffect, useState } from 'react';
import { Button, Card, Container, Row, Col, Form } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { AlertDismissible } from '../../components/alerts';
import { Grid } from '../../components/grid';
import { ConfirmModal } from '../../components/ConfirmModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSearch, faEye } from '@fortawesome/free-solid-svg-icons';
import { ObtenerPaquetesDeViajesCobrosPendientes } from '../../servicios/ServicioPaquetesDeViajes'
import { ObtenerAbonos, ActualizarAprobacionCobrosPaquetesDeViajes } from '../../servicios/ServicioCobro';

import { ModalVisorDocumentos } from '../../components/fileViewer';
const CobrosPaquete = () => {

    const [showAlert, setShowAlert] = useState(false);
    const [mensajeRespuesta, setMensajeRespuesta] = useState({});
    const [listaCobros, setListaCobros] = useState([]);
    const [cobroAprobando, setCobroAprobando] = useState({});
    const [cobroDesAprobando, setCobroDesAprobando] = useState({});
    const [listaClubes, setListaClubes] = useState([]);
    const [paqueteSeleccionado, setPaqueteSeleccionado] = useState({});
    const [apruebaCobro, setApruebaCobro] = useState(false);
    const [DesapruebaCobro, setDesApruebaCobro] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [documentoIndicador, setDocumentoIndicador] = useState(null);
    const [documentoId, setDocumentoId] = useState(null);
    const [NumeroAbono, setNumeroAbono] = useState(null);


    const filterColumns = ['identificacion', 'nombre', 'Descripcion'];

    const encabezadoCobros = [
        { id: 'numAbono', name: 'numAbono', selector: row => row.numAbono, head: "numAbono", width: '15%', omit: true },
        { id: 'IdDocumento', name: 'IdDocumento', selector: row => row.idDocumento !== null ? row.idDocumento : null, head: "IdDocumento", omit: true },
        { id: 'descripcion', name: 'Descripción', selector: row => row.descEstCobros, head: "descripcion", width: '15%' },
        { id: 'pagado', name: 'Monto pagado', selector: row => row.monPagar, head: "pagado", width: '15%' },
        { id: 'fecha', name: 'Fecha del pago', selector: row => row.fecPago, head: "fecha", width: '20%' },
        { id: 'ganadoLoteria', name: 'Loteria', selector: row => row.ganadoLoteria===true ?"Si":"No", head: "fecha", width: '10%' },
        {
            id: 'aprobar', name: 'Aprobar', head: 'aprobar', width: '10%',
            cell: (row) => (
                <div >
                    <Button variant="link" size="sm" onClick={() => handleAprobarCobro(row)}>
                        <FontAwesomeIcon icon={faCheck} style={{ color: 'green', marginLeft: '10px' }} />
                    </Button>
                </div>
            ),
        },
        {
            id: 'Desaprobar', name: 'Desaprobar', head: 'Desaprobar', width: '13%',
            cell: (row) => (
                <div >
                    <Button variant="link" size="sm" onClick={() => handleDesAprobarCobro(row)}>
                        <FontAwesomeIcon icon={faCheck} style={{ color: 'red', marginLeft: '10px' }} />
                    </Button>
                </div>
            ),
        },
        {
            id: 'verDoc',
            name: 'Comprobante',
            head: 'verDoc',
            cell: (row) => {
                if (row.idDocumento !== null) {
                    return (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '60%',
                        }}>
                            <Button variant="link" size="sm" onClick={() => handleAbrirDocumento(row)}>
                                <FontAwesomeIcon icon={faEye} />
                            </Button>
                        </div>
                    );
                }
                return null;
            },
        },
    ];

    const encabezadoClubes = [
        { id: 'identificacion', name: 'Identificación del cliente', selector: row => row.identificacion, head: "identificacion" },
        {
            id: 'nombre', name: 'Nombre del Cliente', selector: row => `${row.nombre} ${row.primerApellido} ${row.segundoApellido}`,
            head: "nombre", width: '29%'
        },
        { id: 'descripcion', name: 'Descripción', selector: row => row.descripcion, head: "descripcion", width: '29%' },
    ];

    const obtenerPaquetesDeViaje = async () => {
        const paquetes = await ObtenerPaquetesDeViajesCobrosPendientes();
        if (paquetes != null && paquetes != undefined) {
            setListaClubes(paquetes);
        }
    }

    const obtenerListadoDeCobros = async (club, mostrarMensaje) => {
        const cobros = await ObtenerAbonos(club);
        const cobrosFormateados = cobros.filter(cobro => cobro.estadoCobro != true); //COBROS QUE NO HAN SIDO APROBADOS
        if (mostrarMensaje && Object.keys(cobrosFormateados).length == 0) {
            setMensajeRespuesta({
                indicador: 1,
                mensaje: 'No hay cobros para el Club de Viaje'
            });
            setShowAlert(true);
        }
        if (cobrosFormateados != null && cobrosFormateados !== undefined) {
            setListaCobros(cobrosFormateados);
        }
        
    }

    useEffect(() => {
        obtenerPaquetesDeViaje();
    }, []);

    const handleAbrirDocumento = async (fila) => {
        setDocumentoId(fila.idDocumento ?? null);
        setNumeroAbono(fila.numAbono);
        setDocumentoIndicador(2); // 2 = paquete
        setShowModal(true);
    };


    const onBuscarCobros = async () => {
        if (paqueteSeleccionado != null && paqueteSeleccionado != null) {
            await obtenerListadoDeCobros(paqueteSeleccionado.id, true);
        }
    }

    const handleAprobarCobro = (cobroClub) => {
        setApruebaCobro(true);
        setCobroAprobando(cobroClub);
    }
    const handleDesAprobarCobro = (cobroClub) => {
        setDesApruebaCobro(true);
        setCobroDesAprobando(cobroClub);
    }
    const onConfirmAprobarCobro = async () => {
        setApruebaCobro(false);
        var cobro = {
            idPaquete: paqueteSeleccionado.id,
            numAbono: cobroAprobando.numAbono,
            idEstado: 1
        }
        const result = await ActualizarAprobacionCobrosPaquetesDeViajes(cobro);
        setMensajeRespuesta(result);
        setShowAlert(true);
        if (result.indicador == 0) {
            await obtenerListadoDeCobros(paqueteSeleccionado.id, false);
        }
        await obtenerPaquetesDeViaje();
    }
    const onConfirmDesAprobarCobro = async () => {
        try {
            setDesApruebaCobro(false);
            var cobro = {
                idPaquete: paqueteSeleccionado.id,
                numAbono: cobroDesAprobando.numAbono,
                idEstado: 0
            }
            const respuesta = await ActualizarAprobacionCobrosPaquetesDeViajes(cobro);

            setMensajeRespuesta(respuesta);
            setShowAlert(true);
            if (respuesta.indicador == 0) {
                await obtenerListadoDeCobros(paqueteSeleccionado.id, false);
            }

            await obtenerPaquetesDeViaje();

        } catch (error) {
            console.error("Error al Desaprobar abono:", error);
        }
    };
    return <>
        {showAlert && (
            <AlertDismissible
                indicador={mensajeRespuesta.indicador}
                mensaje={mensajeRespuesta.mensaje}
                setShow={setShowAlert}
            />
        )}

        <ModalVisorDocumentos
            show={showModal}
            handleClose={() => setShowModal(false)}
            titulo="Información del Pago"
            tamano="lg"
            idDocumento={documentoId}
            indicador={documentoIndicador}
            numAbono={NumeroAbono}
        />


        <Card className="card-container" style={{ width: '100%' }}>
            <Card.Body>
                <Row className="mt-4">
                    <Col>
                        <Card.Title className="card-title"> Aprobar Cobros de Paquetes </Card.Title>
                        <Container className='d-Grid align-content-center'>
                            {/*<div className="d-flex justify-content-left">*/}
                            {/*    <Col md={4}>*/}
                            {/*        <Form.Control type="text"*/}
                            {/*            placeholder="Identificación del cliente"*/}
                            {/*            onChange={this.handleChange.bind(this)}/>*/}
                            {/*    </Col>*/}
                            {/*</div>*/}
                            <div className="d-flex justify-content-end">
                                <Button variant="primary" onClick={onBuscarCobros} size="sm"
                                    className="mr-1 mb-2 card-button" style={{ fontSize: '14px', width: '146.16px' }}>
                                    <FontAwesomeIcon icon={faSearch} className="mr-2" />
                                    Buscar cobros
                                </Button>
                            </div>
                            <Row className="mt-4">
                                <Col md={12}>
                                    <div className="d-flex justify-content-center">
                                        <label><b>Paquetes</b></label>
                                    </div>
                                    <Grid selectableRows={true}
                                        gridHeading={encabezadoClubes}
                                        gridData={listaClubes}
                                        filterColumns={filterColumns}
                                        setFilaSeleccionada={setPaqueteSeleccionado}
                                        className="row col-12 row justify-content-start"
                                        idBuscar="id"
                                        >
                                    </Grid>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col md={12}>
                                    <div className="d-flex justify-content-center">
                                        <label><b>Cobros pendientes del paquete</b></label>
                                    </div>
                                    <Grid selectableRows={false}
                                        gridHeading={encabezadoCobros}
                                        gridData={listaCobros}
                                        setFilaSeleccionada={setCobroAprobando}
                                        setFilaSeleccionada={setCobroDesAprobando}                                    >
                                    </Grid>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        {apruebaCobro && (
           <ConfirmModal
                isOpen={apruebaCobro}
                toggle={() => setApruebaCobro(!apruebaCobro)}
                message={`¿Desea aprobar el cobro ${cobroAprobando.numAbono} con un monto de ${cobroAprobando.monPagar} ?`}
                onConfirm={onConfirmAprobarCobro}
            />
        )}
        {DesapruebaCobro && (
            <ConfirmModal
                isOpen={DesapruebaCobro}
                toggle={() => setDesApruebaCobro(!DesapruebaCobro)}
                message={`¿Desea Desaprobar el cobro ${cobroDesAprobando.numAbono} con un monto de ${cobroDesAprobando.monPagar} ?`}
                onConfirm={onConfirmDesAprobarCobro}
            />
        )}
    </>
}

export default CobrosPaquete;